export default "__VITE_PUBLIC_ASSET__ae01b323__"